module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-result-wrapper card",
    on: {
      "click": function($event) {
        _vm.onClickItem(_vm.item)
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.tankstelle))]), _vm._v(" "), _c('address', {
    staticClass: "my-0"
  }, [_c('small', [_vm._v(_vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.street_number) + " "), _c('br'), _vm._v(_vm._s(_vm.item.address.zip) + " " + _vm._s(_vm.item.address.city))])]), _vm._v(" "), _c('address', {
    staticClass: "my-0"
  }, [_c('small', [_vm._m(0), _vm._v(" " + _vm._s(_vm.item.contact.phone)), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" " + _vm._s(_vm.item.contact.fax)), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto: {{item.contact.email}}'
    }
  }, [_vm._m(2), _vm._v(" " + _vm._s(_vm.item.contact.email) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Telefon"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Fax"
    }
  }, [_c('i', {
    staticClass: "fa fa-fax"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "E-Mail"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61db920d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/searchWidget/resultsTemplate.vue
// module id = 111
// module chunks = 0